const offerPage1 = './pdfs/offer-page1.pdf'
const offerPage2 = './pdfs/offer-page2.pdf'

export { offerPage1, offerPage2 }